import { useMutation } from '@tanstack/react-query';
import { instance } from '@utils/fetch';

const useValidateOtp = () => {
    return useMutation({
        mutationFn: async ({ mfaId, mfaCode, phoneNumber, validateMfaUrl, authToken, xApiKey, logApiEvent }: any) => {
            const webRequestBody = {
                mfaId: mfaId,
                mfaCode: mfaCode,
                phoneNumber: phoneNumber
            };
            return await instance.request({
                method: 'post',
                url: validateMfaUrl,
                data: webRequestBody
            });
        }
    });
};

export { useValidateOtp };
